const blogcomment = {
    add: 'blogcomment/add-by-admin',
    getlist: 'blogcomment/getlist-by-admin',
    update: 'blogcomment/update',
    remove: 'blogcomment/remove',
    get: 'blogcomment/get',
}
export default blogcomment
